import React, { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";

const STATUSES = ["yeni", "uretimde", "tamamlandi", "iptal"];
const LABEL = { yeni: "Yeni", uretimde: "Üretimde", tamamlandi: "Tamamlandı", iptal: "İptal" };
const TYPE = { mum: "Mum", sabun: "Sabun", set: "Hediye Seti" };

export default function AdminCustomOrders() {
  const [list, setList] = useState([]);
  const load = async () => setList((await api.get("/admin/custom-orders")).data);
  useEffect(() => { load(); }, []);

  const update = async (id, patch) => {
    try { await api.put(`/admin/custom-orders/${id}`, patch); toast.success("Güncellendi"); load(); }
    catch (e) { toast.error(formatErr(e)); }
  };
  const remove = async (id) => {
    if (!confirm("Silinsin mi?")) return;
    await api.delete(`/admin/custom-orders/${id}`); load();
  };

  return (
    <div data-testid="admin-custom-orders">
      <h1 className="font-heading text-4xl">Kişiye Özel Talepler</h1>
      <p className="text-larc-muted mt-1">Atölye için gelen özel sipariş talepleri.</p>

      <div className="mt-8 space-y-4">
        {list.length === 0 ? (
          <div className="bg-white border border-larc-border rounded-2xl p-10 text-center text-larc-muted">Henüz talep yok</div>
        ) : list.map((o) => (
          <div key={o.id} className="bg-white border border-larc-border rounded-2xl p-6" data-testid={`custom-${o.id}`}>
            <div className="flex flex-wrap items-start justify-between gap-4">
              <div>
                <div className="text-xs uppercase tracking-[0.18em] text-larc-gold">{TYPE[o.product_type] || o.product_type}</div>
                <div className="font-heading text-2xl mt-1">{o.customer_name}</div>
                <div className="text-sm text-larc-muted mt-1">{o.phone} · {o.email}</div>
              </div>
              <div className="flex items-center gap-2">
                <select value={o.status || "yeni"} onChange={(e) => update(o.id, { status: e.target.value })} className="border border-larc-border rounded-full px-4 py-2 text-sm bg-white" data-testid={`custom-status-${o.id}`}>
                  {STATUSES.map((s) => <option key={s} value={s}>{LABEL[s]}</option>)}
                </select>
                <button onClick={() => remove(o.id)} className="text-larc-muted hover:text-red-600 inline-flex items-center gap-1.5 text-sm"><Trash2 size={14} /> Sil</button>
              </div>
            </div>
            <div className="mt-4 grid sm:grid-cols-2 md:grid-cols-3 gap-3 text-sm">
              <K label="Adet" v={o.quantity} />
              <K label="Koku" v={o.scent} />
              <K label="Renk" v={o.color} />
              <K label="Etiket Yazısı" v={o.label_text} />
              <K label="Hediye Notu" v={o.gift_note} />
              <K label="Referans" v={o.reference_url} link={!!o.reference_url} />
            </div>
            {o.notes && <div className="mt-4 text-sm text-larc-muted"><span className="text-larc-ink font-medium">Not: </span>{o.notes}</div>}
            <div className="mt-4 text-xs text-larc-muted">{new Date(o.created_at).toLocaleString("tr-TR")}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function K({ label, v, link }) {
  return (
    <div>
      <div className="text-xs text-larc-muted uppercase tracking-[0.12em]">{label}</div>
      <div className="mt-0.5 break-words">{link ? <a href={v} target="_blank" rel="noreferrer" className="text-larc-gold hover:underline">{v}</a> : (v || "—")}</div>
    </div>
  );
}
